import React from 'react';
import styled from 'styled-components';
import theme from 'styles/theme';
import { Row, Text } from 'components/pages/market/home/MarketItem';
import useSticky from 'hooks/common/useSticky';

function MarketDetailTabBar({ tabIndex, handleTabIndex }) {
   const { isSticky, stickyRef } = useSticky("market-body", 50); // 50 = 상단바 높이

   return (
      <MarketInfoTabBar ref={stickyRef} isSticky={isSticky}>
         {TABS.map((tab, index) => {
            return (
               <Tab
                  key={tab.name}
                  isSelected={tabIndex === index}
                  onClick={() => handleTabIndex(index)}
               >
                  <Text>{tab.name}</Text>
               </Tab>
            );
         })}
      </MarketInfoTabBar>
   );
}

export default MarketDetailTabBar;

const TABS = [
   {
      name: '판매정보',
   },
   {
      name: '매장정보',
   },
];

const Tab = styled.div`
   user-select: none;
   cursor: pointer;
   width: 100%;
   text-align: center;

   ${Text} {
      width: fit-content;
      padding: 10px 0px;
      margin: 0 auto;
      border-bottom: 2px solid
         ${({ isSelected }) => (isSelected ? theme.color.orange : theme.color.white)};
      color: ${({ isSelected }) => (isSelected ? theme.color.orange : theme.color.black)};
   }
`;
const MarketInfoTabBar = styled(Row)`
   position: ${({ isSticky }) => (isSticky ? 'sticky' : 'relative')};
   top: 0px;
   width: 100%;
   background-color: ${theme.color.white};
`;
